import { render, staticRenderFns } from "./BtnInserirRecurso.vue?vue&type=template&id=52b65386&"
import script from "./BtnInserirRecurso.vue?vue&type=script&lang=js&"
export * from "./BtnInserirRecurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports